import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  AddAppInvitationPayload,
  DeleteAppInvitationPayload,
  FetchAppInvitationsPayload,
  IAppInvitation,
  ResendAppInvitationPayload,
} from '../types/app-invitation.types';

export const appInvitationApi = createApi({
  reducerPath: 'appInvitationApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin`),
  endpoints: (builder) => ({
    fetchAppInvitations: builder.query<ApiPaginationResponse<IAppInvitation[]>, FetchAppInvitationsPayload>({
      query: (params) => ({
        url: '/app-invitations',
        method: 'GET',
        params,
      }),
    }),
    addAppInvitation: builder.mutation<ApiResponse<IAppInvitation>, AddAppInvitationPayload>({
      query: (payload) => ({
        url: '/app-invitations',
        method: 'POST',
        body: payload,
      }),
    }),

    resendAppInvitation: builder.mutation<ApiResponse<void>, ResendAppInvitationPayload>({
      query: (payload) => ({
        url: `/app-invitations/${payload.id}`,
        method: 'PUT',
      }),
    }),

    deleteAppInvitation: builder.mutation<ApiResponse<any>, DeleteAppInvitationPayload>({
      query: (payload) => ({
        url: `/app-invitations/${payload.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useLazyFetchAppInvitationsQuery,
  useAddAppInvitationMutation,
  useResendAppInvitationMutation,
  useDeleteAppInvitationMutation,
} = appInvitationApi;
